import { useEffect } from 'react';

import type { Sport } from '#src/__generated__/globalTypes.ts';
import { useLocalStorage } from '#src/hooks/useLocalStorage.ts';

import { useSportContext } from './index.ts';

type Props = {
  sport: Sport;
};

export const SportSwitcher = ({ sport }: Props) => {
  const { sport: currentSport, setSport } = useSportContext();
  const [storedSport, setSportStorage] = useLocalStorage('sport', undefined);
  useEffect(() => {
    if (sport !== currentSport || sport !== storedSport) {
      setSport(sport);
      setSportStorage(sport);
    }
  });

  return null;
};
